const TRAIN_UPDATED = (state, Train) => {
  state.Train = Train
}

export default {
  TRAIN_UPDATED
}
